export const FILE_TYPE_MAP = {
  'image/jpeg': { type: 'image', icon: '🖼️', maxSize: 5 },
  'image/jpg': { type: 'image', icon: '🖼️', maxSize: 5 },
  'image/png': { type: 'image', icon: '🖼️', maxSize: 5 },
  'image/gif': { type: 'image', icon: '🖼️', maxSize: 5 },
  'image/webp': { type: 'image', icon: '🖼️', maxSize: 5 },
  'application/pdf': { type: 'pdf', icon: '📄', maxSize: 10 },
  'application/vnd.ms-excel': { type: 'excel', icon: '📊', maxSize: 5 },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': { type: 'excel', icon: '📊', maxSize: 5 },
  'application/msword': { type: 'word', icon: '📝', maxSize: 5 },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': { type: 'word', icon: '📝', maxSize: 5 },
  'application/vnd.ms-powerpoint': { type: 'powerpoint', icon: '📽️', maxSize: 5 },
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': { type: 'powerpoint', icon: '📽️', maxSize: 5 },
  'audio/webm': { type: 'voice', icon: '🎤', maxSize: 5 },
  'audio/mp4': { type: 'voice', icon: '🎤', maxSize: 5 },
  'audio/mpeg': { type: 'voice', icon: '🎤', maxSize: 5 },
};